import type { IntegrationSettings } from '../types';
import { DEFAULT_KITCHEN_ALERT_SOUND } from '../lib/kitchenAlertSound';

export const initialIntegrationSettings: IntegrationSettings = {
  'Uber Eats': {
    enabled: true,
    apiKey: 'UE-LIVE-API-KEY-GOES-HERE',
    clientSecret: 'SECRET_CLIENT_STRING_FOR_UBER_EATS',
    storeId: 'a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6',
  },
  'DoorDash': {
    enabled: false,
    apiKey: '',
    clientSecret: '',
    storeId: '',
  },
  smartpay: {
    terminals: [],
    posVendorName: 'KINGS PARK POS',
    posBusinessName: 'Kings Park Restaurant',
  },
  receiptPrinters: [
    {
        id: 'print-1',
        name: 'Main Counter Printer',
        enabled: true,
    }
  ],
  kitchenSLA: {
    warningMinutes: 5,
    dangerMinutes: 10,
    minutesToStart: 5,
    minutesToServe: 5,
    alertSoundEnabled: true,
    alertSoundUrl: DEFAULT_KITCHEN_ALERT_SOUND,
    alertSoundVolume: 100,
    kitchenDisplayTextSize: 'large',
  },
  businessInfo: {
    businessName: 'KINGS PARK',
    address: '123 Restaurant Ave, Food City',
    gstNumber: '123-456-789',
    phone: '',
    email: '',
    website: '',
    onlineOrderingEnabled: false,
  },
  businessHours: {
    timezone: 'Pacific/Auckland',
    days: [
      { day: 'monday', open: '11:00', close: '22:00' },
      { day: 'tuesday', open: '11:00', close: '22:00' },
      { day: 'wednesday', open: '11:00', close: '22:00' },
      { day: 'thursday', open: '11:00', close: '23:00' },
      { day: 'friday', open: '11:00', close: '23:59' },
      { day: 'saturday', open: '11:00', close: '23:59' },
      { day: 'sunday', open: null, close: null, closed: true },
    ],
  },
  eventStall: {
    enabled: false,
    name: '',
    eventMenuItems: [],
  },
  recipeInventoryMode: 'inventory_connected',
};